module.exports = __webpack_public_path__ + "img/gno.6a3745f4.svg";